import * as download from 'downloadjs';

import { ResponseTypes, sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';
import { getFavoritesRequestParams } from '../common/favoritesServiceHelper';

export function getTemporaryLicenses() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_full_temporary_licenses'
      })
    }
  );
}

export function getTemporaryLicenseById(temporaryLicenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_temporary_license_by_id',
        id: temporaryLicenseId,
      })
    }
  );
}

export function createNewTemporaryLicenses(clientId, productName, type, features, term, licenseCount = null, obtainingMethod = 'free') {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'create_new_temporary_license',
        client_id: clientId,
        product_name: productName,
        type, features, term,
        license_count: licenseCount,
        obtaining_method: obtainingMethod
      })
    }
  );
}

export function updateTemporaryLicense(licenseId, features, term = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'update_temporary_license',
        temp_lic_id: licenseId,
        features, term
      })
    }
  );
}

export function getTemporaryLicenseHistory(licenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_temporary_license_history',
        temp_lic_id: licenseId
      })
    }
  );
}

export function deactivateTemporaryLicense(temporaryLicenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'deactivate_temporary_license',
        temp_lic_id: temporaryLicenseId
      })
    }
  );
}


export function getTemporaryLicenseByKey(licenseKey = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_temporary_license_by_key',
        license_key: licenseKey
      })
    }
  ).then(license => Object.keys(license).length === 0 ? null : license);
}

export function assignLicenseToClient(licenseId, clientId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'assign_temporary_license_to_client',
        license_id: licenseId,
        client_id: clientId
      })
    }
  );
}

export function activateLicense(licenseId, deviceKey = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'activate_temporary_license',
        license_id: licenseId,
        device_key: deviceKey
      })
    }
  );
}

export function downloadTemporaryLicense(licenseId = null) {
  return sendRequestWithAuth(
    `${settings.ServerURL}?operation=get_temporary_license_file&license_id=${licenseId}`, {
      method: 'GET'
    }, ResponseTypes.file
  ).then(file => download(file.data, file.name)).catch(error => {
    throw error
  });
}

export function getTemporaryLicenseHistoryById(licenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_temporary_license_history_by_id',
        id: licenseId
      })
    }
  );
}

export function addTemporaryLicenseToFavorites(licenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'temporary_license', 'add', licenseId
    )
  );
}

export function removeTemporaryLicenseFromFavorites(licenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'temporary_license', 'remove', licenseId
    )
  ).then(license => license).catch(error => {
    throw error
  });
}



// WEBPACK FOOTER //
// ./src/services/temporaryLicenses.js